// hooks/useAuth.js
import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth必須在AuthProvider內使用');
    }
    return context;
};

export default useAuth;